import {FC} from "react";
import {Card, Col} from "react-bootstrap";
import Loader from "@/components/common/loader/loader";
import useLeadingIndicators from "@oldDashboard/legacyHooks/useLeadingIndicators";
import ResultKPI from "../goals/launch-kpis/components/ResultKPI";
import { LeadingIndicator } from "@oldDashboard/legacyModels/leadingIndicador.model";
import { getFiltersDate } from "@oldDashboard/legacyUtils";
import { TimePeriods } from "@oldDashboard/legacyModels/timePeriods.model";
import MessageCard from "@oldDashboard/components/MessageCard";
import { dashboardState } from "@oldDashboard/legacyStores/dashboardClient";
interface ConversionLeadingIndicatorsProps { data: LeadingIndicator, timePeriods: TimePeriods[], affiliateSelected: String,launchSelected: String, timePeriodSelected: string,  searching: boolean }
const ConversionLeadingIndicatorsTile: FC<ConversionLeadingIndicatorsProps> = (props: ConversionLeadingIndicatorsProps) => {
    const { data, timePeriods, affiliateSelected,launchSelected, timePeriodSelected, searching } = props;
    
    const { startDate, endDate } = getFiltersDate(timePeriods,timePeriodSelected);
    const { isLoading } = useLeadingIndicators({ affiliateSelected,launchSelected, timePeriodSelected, startDate, endDate, searching});
    
    const conversionLaunchKPISizesCard = () => {
        let kpi_xxl=6, kpi_xl=6, kpi_l=6, kpi_m=6; 
        if(dashboardState.state.recommendedActions.data.length == 0) {
            kpi_xxl = 6;
            kpi_xl = 6;
            kpi_l = 12;
            kpi_m = 12;
        }
        return {
            kpi_xxl,
            kpi_xl,
            kpi_l,
            kpi_m
        }
    }
    
    const { kpi_xxl, kpi_xl, kpi_l, kpi_m } = conversionLaunchKPISizesCard();
    if(!data.show_launch_kpi) {
        return null;
    }
    if (data == null) return (
        <MessageCard title="Launch KPI" message="At the moment, we don't have any KPI's available for viewing. 
        However, we're continuously creating new content, so please check back soon for new additions!"/>
    )
    
    return (
        <Col xxl={kpi_xxl} xl={kpi_xl} lg={kpi_l} md={kpi_m}>
            <Card className="custom-card" style={{minHeight: 250}}>
                { isLoading && <Loader/> }
                <Card.Header>
                    <Card.Title>
                        Launch KPIs
                    </Card.Title>
                </Card.Header>
                <Card.Body className="px-3 mb-0 pt-2 pb-0">
                    <div className="overflow-x-scroll container-scrollable w-100 d-flex flex-nowrap">
                        {data.data.map((indicator: any) => (
                            <ResultKPI indicator={indicator} key={Math.random()}/>
                        ))}
                    </div>
                </Card.Body>
            </Card>
        </Col>
    );
};

export default ConversionLeadingIndicatorsTile;
